import api from '@pray/shared/utils/api';

type DateRangeParams = {
  startDateTime: string;
  endDateTime: string;
};

type PaginationParams = {
  cursor?: string | null;
  limit?: number;
};

export async function getCampaignsByStatus(params: DateRangeParams) {
  const response = await api.executeGetRequest('/web/studio/crm-analytics/campaigns-by-status', params);
  return response.data;
}

export async function getCampaignsByMetrics(params: DateRangeParams) {
  const response = await api.executeGetRequest('/web/studio/crm-analytics/campaigns-by-metrics', params);
  return response.data;
}

export async function getSendsByArtist(params: DateRangeParams & PaginationParams) {
  const response = await api.executeGetRequest('/web/studio/crm-analytics/sends-by-artist', params);
  return response.data;
}

type CampaignListParams = DateRangeParams &
  PaginationParams & {
    status?: string;
    artistId?: string;
    domainId?: string;
    sortBy?: string;
    sortDir?: 'asc' | 'desc';
    search?: string;
  };

export async function getDomainPerformance(params: DateRangeParams) {
  const response = await api.executeGetRequest('/web/studio/crm-analytics/domain-performance', params);
  return response.data;
}

export async function getCampaigns(params: CampaignListParams) {
  const response = await api.executeGetRequest('/web/studio/crm-analytics/campaigns', params);
  return response.data;
}

type AutomationListParams = DateRangeParams &
  PaginationParams & {
    status?: string;
    artistId?: string;
    triggerType?: string;
    sortBy?: string;
    sortDir?: 'asc' | 'desc';
    search?: string;
  };

export async function getAutomationsByStatus(params: DateRangeParams) {
  const response = await api.executeGetRequest('/web/studio/crm-analytics/automations-by-status', params);
  return response.data;
}

export async function getAutomationsByArtist(params: DateRangeParams) {
  const response = await api.executeGetRequest('/web/studio/crm-analytics/automations-by-artist', params);
  return response.data;
}

export async function getTriggerDistribution(params: DateRangeParams) {
  const response = await api.executeGetRequest('/web/studio/crm-analytics/trigger-distribution', params);
  return response.data;
}

export async function getExecutionFunnel(params: DateRangeParams) {
  const response = await api.executeGetRequest('/web/studio/crm-analytics/execution-funnel', params);
  return response.data;
}

export async function getAutomations(params: AutomationListParams) {
  const response = await api.executeGetRequest('/web/studio/crm-analytics/automations', params);
  return response.data;
}
